<template>
  <div>
    <pc-header></pc-header>
    <div class="header-wrap">
      <img src="@/assets/images/news/news-head-bg.png" />
    </div>

    <div class="content-wrap">
      <div class="title">做支付需要了解哪些行业知识</div>
      <div class="time">2020-11-25 13:56</div>
     <div class="RichText ztext Post-RichText css-hnrfcf" options="[object Object]"><p data-pid="xjuLeGra">刚进入支付行业的朋友们，做支付有哪些需要了解的行业知识呢？微派（wiipay）带你了解支付。</p><p data-pid="lmdYSUb7">一、二清：</p><p data-pid="mhkuT6NI">即是二次清算。 支付机构将资金结算给了平台，平台再自行将资金清算给下游的商户客户。如果平台没有清算资质（支付牌照），就算违规二清。国家管控二清行为主要是防范平台吸收资金后并且挪用资金进行高风险投资甚至卷款跑路，如今对于平台而言账户里沉淀了资金反而烫手。</p><p data-pid="orbxgXTj"><br>二、支付牌照：</p><p data-pid="YYARbzCq">即《第三方支付的业务许可证》，央行颁发，受央行监管。</p><p data-pid="2AFCnZeH">主要分为三种牌照：银行卡收单(主要形式为POS机刷卡)、互联网支付、预付卡发行与受理。</p><p data-pid="ltKrreHm"><br>支付牌照之前抢手原因是申请门槛太高，需央行审核发照。更重要的是央行几乎停止发牌照了(吊销的牌照的比新发的还多)。全国仅存200家左右第三方支付公司，能做互联网支付的应该不到一百家了。备付金收归央行管理后，支付公司纯靠支付手续费躺着挣钱越来越难了。更多的支付公司指望能像支付宝一样将流量变现，做征信、理财、借贷、异业营销等。</p><p data-pid="7pbrnSjY">三、怎么避免二清？</p><p data-pid="KacALU9O">电商(包括类似模式的)平台多如牛毛，有牌照的寥寥无几。虽然很多平台在这块都涉及违规操作，但估计是因为央行没工夫和这些规模不大的平台计较，也给行业新生企业一定的发展调整的空间和时间作为平台避免二清当然最好是有支付牌照。这里只说没有牌照的方式。</p><p data-pid="JRgvTvld">1、第三方支付公司、有开发能力的银行都逐渐推出了自己的分账系统，交易资金不直接到平台，而是到平台以及下属商户在这些机构开立的托管账户中。平台方不触碰资金。有人说了，虽然托管账户的钱平台不能直接提现，但是分账的指令是平台发给机构的，信息流控制了资金流，这样还是能间接把资金清到平台的可提现户。是的，不过一是机构会有风控，二是如果平台连编造交易（编造信息流）这种事情都干得出来还接分账系统立这牌坊干啥？</p><p data-pid="iEd5vycN">2、微信分账系统，各位自行了解下。个人觉得很方便很强大。比起对接银行机构的分账系统，开发成本会小很多。</p><p data-pid="-NdAW71A">四、代收和代付：</p><p data-pid="j4u6YBoa">代收，也叫代扣，免密支付。用户签署协议授权企业可以直接从用户账户里扣钱。常见场景：滴滴打车，高德打车下车即走自动扣款，买会员卡自动续期的时候要注意了。整个环节无需用户输密码或者手机验证码验证，接口过于敏感，一般支付宝微信也只向有深度合作的企业开放这类接口。<br>代付。一般是企业向下属用户或者商家付款。出款账户一般为在机构开立的备付金专户（注意支付机构不会直接操作对公银行卡账户）。常用于结算、提现等T+1和D+1T+1到账：即今天交易的资金，下一个工作日到账。<br>D+1到账：即今天交易的资金，明天到账（不分工作日）</p><p data-pid="rZL39wzs">五、长款和短款</p><p data-pid="PXF70sgm">完善的支付系统都需要有对账系统的辅助，来及时发现系统的差错，核实资金。<br>对账的最终结果有两种：</p><p data-pid="SjxVzvfN">长款: 钱收多了（比如订单被重复支付或其他系统bug）</p><p data-pid="scwhxxJw">短款: 钱收少了（如跨日临界点的交易因为时间差导致的统计偏差）</p><p data-pid="OU92jj1e">重复支付和无效支付</p><p data-pid="YmSPZjh2">很多人看到这个问题觉得这就是个很low的bug，</p><p data-pid="sLPxN1kC">事实上有些场景重复支付无法从程序上避免。 <br>举例1   我美团上下了一个订单，先选择支付宝支付，唤起支付宝收银台页面然后先不支付，打开美团订单页，选择微信支付完成支付。这时候打开支付宝会发现支付宝仍然停留在收银台页面就等着你输密码了，输入密码完成支付。结果是支付宝微信都支付成功了！  有人说哪有这么傻的用户自己都不知道自己付了几次，其实是弱网环境下用户也不知道前一种支付方式有没有成功。</p><p data-pid="YNoEJ2Gx">举例2： 我在12306上下单占了一张二等座的票。提示座席被锁定订单需在10分钟内完成支付否则将自动关闭。选择支付宝支付，等待10分钟以后再点击支付完成。支付完成了。但是订单已经关闭了座位也没了。结果是付了钱没买到票。</p><p data-pid="iiLl9Qr2">这两者我都定义为无效支付。即“一手交钱，一手交货”只完成了一半。个人觉得这种场景无法杜绝，但需要有个兜底的方案：发起原路退款，根据实际业务场景决定退款是否需要人工审核。</p><p data-pid="W5MbKExa">六、银联：</p><p data-pid="kTPdbrNy">中国银联是中国银行卡联合组织，全国两千多家商业银行，银联搭建起了一个可以跨行交易清算的系统。当然雁过拔毛，比如线下POS刷卡的手续费，一般按找7:2:1的比例分别分给发卡行、收单机构、银联。（这里的收单机构可能是第三方支付公司或者银行，即如果发卡行和收单机构都为中国银行，那中国银行拿90%手续费）</p><p data-pid="I9QNQ-nC">七、网联：</p><p data-pid="V98W3uaA">然而最初的支付宝是没有接入银联的，而是绕过银联直接和银行对接，当然不可能把两千家银行对接个遍，只是对接我们常见的一些大行，所以支持的银行卡有限，但对于C端消费者来说完全足够了。为了对此类交易和资金进行监管，央行批准成立网联。并且要求各第三方支付机构不再直接对接银行，而是由网联作为中间平台转接，即常说的断直连。</p><p data-pid="Pm8juTxE">共同点：二者都为中国的支付清算组织，由中国人民银行批准成立。</p><p data-pid="YNx0UORY">主要差异： 银联倾向于管理线下银行卡收单，网联倾向于管理支付宝微信等移动支付。</p><p class="ztext-empty-paragraph"><br></p><p data-pid="7m0suBlt"></p></div>
    </div>
    <pc-footer></pc-footer>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {}
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.header-wrap {
  // margin-top: -60px;
}
img {
  width: 100%;
  object-fit: cover;
}

.content-wrap {
  padding-top: 50px;
  padding-bottom: 50px;
  width: 900px;
  margin: 0 auto;

  .title {
    font-size: 32px;
    font-weight: bold;
    line-height: 38px;
    color: #000000;
    opacity: 0.85;
    text-align: center;
  }
  .time {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: #a8a8a8;
    margin-top: 15px;
    text-align: center;
  }
  .css-hnrfcf {
    word-break: break-word;
    line-height: 1.6;
    margin-top: 20px;
    color: #000000;
  }
  .css-hnrfcf > *:first-of-type {
    margin-top: 0;
  }
  .css-hnrfcf p {
    margin: 1.4em 0;
  }
}
</style>